/*
 * View for the topic label modal
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/admin/userAdministration/userDetails/basicUserInfoDisplay/template/basicUserInfoTemplate.html",
], function ($, Marionette, Messenger, BasicUserInfoTemplate) {
  "use strict";

  const BasicUserInfoView = {};

  BasicUserInfoView.basicUserInfoView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: BasicUserInfoTemplate,
    showError: function (div, errorMessage) {
      this.$el
        .find(div)
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    events: {
      "change #enabledStatus": function (e) {
        const value = $(e.target).val();
        this.trigger("change:enabledStatus", value);
      },
    },
    textboxes: {
      "#userLogin": {
        enableSelector: ["#userLoginLabel", "#userLogin"],
        modelAttribute: "userLogin",
        placeholder: "admin.userAdministration.login",
        textArea: false,
      },
      "#userFullName": {
        enableSelector: ["#userFullNameLabel", "#userFullName"],
        modelAttribute: "userFullName",
        placeholder: "admin.userAdministration.fullName",
        textArea: false,
      },
      "#organization": {
        enableSelector: ["#organizationLabel", "#organization"],
        modelAttribute: "userOrganization",
        placeholder: "admin.userAdministration.organization",
        textArea: false,
      },
      "#email": {
        enableSelector: ["#emailLabel", "#email"],
        modelAttribute: "userEmail",
        placeholder: "admin.userAdministration.emailAddress",
        textArea: false,
      },
      "#phone": {
        enableSelector: ["#phoneLabel", "#phone"],
        modelAttribute: "userPhone",
        placeholder: "admin.userAdministration.phoneNumber",
        textArea: false,
      },
      "#password": {
        enableSelector: ["#passwordLabel", "#password"],
        modelAttribute: "password",
        textArea: false,
        placeholder: "admin.userAdministration.password",
        isPassword: true,
      },
      "#reenterPassword": {
        enableSelector: ["#reenterPasswordLabel", "#reenterPassword"],
        modelAttribute: "reenterPassword",
        textArea: false,
        placeholder: "admin.userAdministration.reenterPassword",
        isPassword: true,
      },
      "#botEmail": {
        enableSelector: ["#botEmailLabel", "#botEmail"],
        modelAttribute: "botEmail",
        placeholder: "admin.userAdministration.botEmail",
        textArea: false,
      },
      "#botCompany": {
        enableSelector: ["#botCompanyLabel", "#botCompany"],
        modelAttribute: "botCompany",
        placeholder: "admin.userAdministration.botCompany",
        textArea: false,
      },
    },
    triggers: {
      "click #tenantAdmin": "toggle:tenant:admin",
      "click #btnChangePassword": "set:password",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date:long", date);
      },
    },
  });

  return BasicUserInfoView;
});
